<template>
  <div class="row justify-content-center mt-5 mb-3 px-2">
    <div class="col">
      <div class="row menutab">
        <div class="col col-md-auto">
          <router-link to="/privacy-policy" class="">
            PrivacyPolicy
          </router-link>
        </div>
        <div class="col col-md-auto">
          <router-link to="/cookies-policy" class=""
            >Cookies Policy</router-link
          >
        </div>
        <div class="col col-md-auto">
          <router-link to="/privacy-notice" class=""
            >Privacy Notice</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "account-tab-menu",
};
</script>

<style lang="scss" scoped>
.menutab {
  cursor: pointer;
  text-decoration: none;

  a {
    text-decoration: none !important;
  }

  .active {
    border-bottom: 3px solid #1e7de8;
  }
}

::-webkit-scrollbar {
  height: 1px; /* height of horizontal scrollbar ← You're missing this */
  width: 1px; /* width of vertical scrollbar */
}
</style>
